import React, { useEffect, useRef } from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import BasePage from "components/BasePage";
import BlockStudents from "./components/BlockStudents";
import BlockUniversities from "./components/BlockUniversities";
import BlockWWHTestimonials from "./components/BlockWWHTestimonials";
import WhoWeHelpLinks from "./components/WhoWeHelpLinks";
import "./style.scss";

export default function PageWhoWeHelp({ type }: { type: string }) {
  useEffect(() => {
    const main = document.querySelector(".main");
    main?.classList.add("bg-white");
    return () => main?.classList.remove("bg-white");
  }, []);

  const nodeRef = useRef(null);

  return (
    <BasePage className="page-who-we-help">
      <WhoWeHelpLinks isUniversity={type !== "students"} />
      <SwitchTransition mode="out-in">
        <CSSTransition key={type} timeout={300} nodeRef={nodeRef} classNames="fade">
          <div ref={nodeRef}>
            {type === "students" ? (
              <>
                <BlockStudents />
                <BlockWWHTestimonials />
              </>
            ) : (
              <BlockUniversities />
            )}
          </div>
        </CSSTransition>
      </SwitchTransition>
    </BasePage>
  );
}
